import { dopplerAbi } from "doppler-v4-sdk"
import { Address } from "viem"
import { useReadContract } from "wagmi"
import { CHAIN_ID } from "./constants"

/**
 * This hook returns the poolKey object needed for getting quotes and sending transactions with the doppler packages
 * @param poolAddress The coin's pool address
 * @returns poolKey object
 */
export function usePoolKey(poolAddress: string) {
  const { data: poolKey } = useReadContract({
    address: poolAddress as Address,
    abi: dopplerAbi,
    functionName: "poolKey",
    chainId: CHAIN_ID,
    query: {
      select: (data) => ({
        currency0: data[0],
        currency1: data[1],
        fee: data[2],
        tickSpacing: data[3],
        hooks: data[4],
      }),
    },
  })

  return poolKey ?? null
}
